// k3s-development build target (Story 37.16) — the in-cluster nginx image
// for the dev k3s stack (consolidated single-hostname model, FR19).
//
// brand-site and the auth API share ONE hostname behind Traefik path routing
// (unlike admin-ui, which Story 37.20 carved out to its own admin.<env> —
// see that story's Dev Notes if this sentence and adminSigninBaseUrl below
// look inconsistent; they're not, admin-ui is the deliberate exception), so
// every cross-surface / API URL becomes a same-origin PATH: the API values
// are absolute paths HttpClient resolves against the current origin, and
// `adminSigninBaseUrl` points at the admin console's OWN hostname (Story
// 37.20). It was a relative `/admin-ui/signin` while the console lived behind
// a path prefix on the consolidated host; that prefix no longer exists, so this
// must be absolute or the signup handoff dead-ends.
// Host-independent by construction — the same image serves the k3s
// validation host today and the canonical host after the 37.20 cutover.
export const environment = {
  production: false,
  envLong: 'development',
  tenantSignupUrl: '/tenant-signup',
  publicTermsUrl: '/terms/active',
  adminSigninBaseUrl: 'https://admin.development.emjo-consulting.dk/signin',
  // Code-review 2026-08-07: derived at runtime, NOT copied from
  // tenantSignupUrl's origin — tenantSignupUrl is deliberately a same-origin
  // RELATIVE path here (see above), and `new URL('/tenant-signup')` throws
  // (no base argument) wherever something tried to reuse it as an origin
  // source. `location.origin` is exactly correct under the consolidated
  // single-hostname model: whatever hostname served this page IS the auth
  // API's origin, by construction — true on both the validation host and the
  // canonical host, with no hostname string to keep in sync.
  // 46.10 code review: was `location.origin`, which was correct only while
  // the brand site was served FROM the auth host at /brand-site. On its own
  // ianua.<env> hostname it started naming the BRAND host, and the only
  // consumer is the public integration docs, which render
  // `{{authBase}}/.well-known/openid-configuration` and `/jwks.json`.
  // Those paths are not routed on ianua, so the brand SPA's catch-all
  // answered 200 text/html — an integrator following the docs got a JSON
  // parse error against a 200, not a 404. Verified live on prod before the
  // fix. This value DOCUMENTS the auth host; it is not used for any fetch
  // (grep: the docs component is the sole reader), so an absolute URL costs
  // nothing in same-origin terms and does not touch CSP connect-src 'self'.
  // The story's "host-independent by construction" note conflated
  // same-origin API calls (still relative, still correct) with naming the
  // auth host (host-dependent).
  authOrigin: 'https://auth.development.emjo-consulting.dk',
  recaptchaSiteKey: '6LcDrv4sAAAAAPnZZjh6DZNrts9K4PlUpWkaD9SE', //gitleaks:allow -- public reCAPTCHA site key (shipped to browser)
};
